import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import FileSaver from 'file-saver';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import PickListIndexActions, { PickListIndexTypes } from '../Stores/PickListIndex/Actions';

const getAppStore = state => state.app;

export function* pickListIndexFetchPickListIndex({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(PickListIndexActions.pickListIndexFetchPickListIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `pickList/index/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        PickListIndexActions.pickListIndexFetchPickListIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PickListIndexActions.pickListIndexFetchPickListIndexLoading(false));
  }
}

export function* pickListIndexGoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/pickListDetail/update/${hdrId}`));
}

export function* pickListIndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/PICK_LIST/${hdrId}/PickListHdr`));
}

export function* pickListIndexGoToPrint({ document }) {
  try {
    yield put(PickListIndexActions.pickListIndexFetchPickListIndexLoading(true));

    const app = yield select(getAppStore);

    const getData = {
      hdrIds: [document.id]
    };

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `pickList/print/${app.curSiteFlowId}`,
      app.token,
      getData,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      FileSaver.saveAs(result.data, 'PickList.pdf');
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PickListIndexActions.pickListIndexFetchPickListIndexLoading(false));
  }
}

export function* pickListIndexExcelOutbOrdDtls({ document }) {
  try {
    yield put(PickListIndexActions.pickListIndexFetchPickListIndexLoading(true));

    const app = yield select(getAppStore);

    const getData = {
      hdrIds: [document.id]
    };

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `pickList/excelOutbOrdDtls/${app.curSiteFlowId}`,
      app.token,
      getData,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      FileSaver.saveAs(result.data, 'PICK_LIST_OUTB_ORD_DTLS.XLSX');
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PickListIndexActions.pickListIndexFetchPickListIndexLoading(false));
  }
}

export const saga = [
  takeLatest(PickListIndexTypes.PICK_LIST_INDEX_GO_TO_DOCUMENT, pickListIndexGoToDocument),
  takeLatest(PickListIndexTypes.PICK_LIST_INDEX_GO_TO_AUDIT, pickListIndexGoToAudit),
  takeLatest(
    PickListIndexTypes.PICK_LIST_INDEX_FETCH_PICK_LIST_INDEX,
    pickListIndexFetchPickListIndex
  ),
  takeLatest(PickListIndexTypes.PICK_LIST_INDEX_GO_TO_PRINT, pickListIndexGoToPrint),
  takeLatest(PickListIndexTypes.PICK_LIST_INDEX_EXCEL_OUTB_ORD_DTLS, pickListIndexExcelOutbOrdDtls)
];
